/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnamesBind from 'classnames/bind';
import NavMenu from '@concur/nui-widgets/NavMenu';
import Icon from '@concur/nui-widgets/Icon';
import { withFormatter } from '@concur/nui-intl-runtime';
import { compose } from '@concur/core-ui-shell';
import { getSideNavIcon } from '../utils/sideNavIconMap';
import convertJavascriptUrl from '../utils/convertJavascriptUrl';
import styles from './SideNav.css';

const CSS_PREFIX = 'sapcnqr';
const CSS_BLOCK = 'sapcnqr-sidenav';

const SideNavItem = React.forwardRef((props, ref) => {
    const {
        className,
        item,
        formatter,
        inOverflowMenu,
        href,
        /* eslint-disable react/prop-types */
        lang,
        /* eslint-enable react/prop-types */
        ...otherProps
    } = props;

    const classnames = classnamesBind.bind(styles);
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const getLabelContent = () => {
        if (inOverflowMenu) {
            return item.name;
        } if (isHovered) {
            return (
                <>
                    <Icon data-test="label-icon-with-name" iconName={getSideNavIcon(item.id)} ariaHidden />
                    {item.name}
                </>
            );
        }
        return (<Icon data-test="label-icon" iconName={getSideNavIcon(item.id)} ariaLabel={item.name} />);
    };

    return (
        <NavMenu.Item
            {...otherProps}
            {...convertJavascriptUrl(href, item.id)}
            ref={ref}
            className={classnames(
                CSS_PREFIX,
                className,
                {
                    // only add hovered styles if the item is not in overflow menu
                    [`${CSS_BLOCK}__list-item--hovered`]: !inOverflowMenu && isHovered,
                    [`${CSS_BLOCK}__list-item--focused`]: !inOverflowMenu && isFocused,
                },
            )}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => {
                // do not remove hover styles if the item is focused
                if (!isFocused) {
                    setIsHovered(false);
                }
            }}
            onFocus={() => {
                setIsHovered(true);
                setIsFocused(true);
            }}
            onBlur={() => {
                setIsHovered(false);
                setIsFocused(false);
            }}
            label={getLabelContent()}
        />
    );
});

SideNavItem.displayName = 'SideNavItem';

SideNavItem.propTypes = {
    className: PropTypes.string,
    item: PropTypes.object,
    inOverflowMenu: PropTypes.bool,
    href: PropTypes.string,
};

export default compose(
    withFormatter,
)(SideNavItem);
